import React from 'react'
import './couple.css'
import Photocouple from './Photocouple';
import Nophotocouple from './Nophotocouple';
const Couple = ({details,photoMode}) => {

    const databaseHasPhoto = details?.coupleType === "photoCouple";

      const hasPhoto =
    photoMode === "photo"
      ? true
      : photoMode === "no-photo"
      ? false
      : databaseHasPhoto;


return hasPhoto? (
     <Photocouple  details={details} />
  ):(
    <Nophotocouple details={details} />
  )

}

export default Couple